/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentType {
    SessionFee = 'Session Fee',
    Reuse = 'Reuse',
    HoldingFee = 'Holding Fee',
    Other = 'Other',
}
